import formatPrice from 'utils/formatPrice';
import { ICartProduct } from 'models';

import { useCart } from 'contexts/cart-context';
import { useI18n } from 'contexts/i18n-context';

import * as S from './style';

interface IProps {
  product: ICartProduct;
}
const CartProduct = ({ product }: IProps) => {
  const { removeProduct, increaseProductQuantity, decreaseProductQuantity } =
    useCart();
  const { t } = useI18n();
  const {
    title,
    price,
    currencyId,
    currencyFormat,
    categoryName,
    packageSpec,
    unit,
    quantity,
  } = product;

  const handleRemoveProduct = () => removeProduct(product);
  const handleIncreaseProductQuantity = () => increaseProductQuantity(product);
  const handleDecreaseProductQuantity = () => decreaseProductQuantity(product);

  return (
    <S.Container>
      <S.DeleteButton
        onClick={handleRemoveProduct}
        title={t('cart.removeProduct')}
      >
        x
      </S.DeleteButton>
      <S.Details>
        <S.Title>{title}</S.Title>
        <S.Desc>
          {[categoryName, packageSpec, unit].filter(Boolean).join(' / ')} <br />
          {`${t('cart.quantity')}: ${quantity}`}
        </S.Desc>
      </S.Details>
      <S.Price>
        <p>
          {price === null
            ? t('product.priceUnavailable')
            : `${currencyFormat}  ${formatPrice(price, currencyId)}`}
        </p>
        <div>
          <S.ChangeQuantity
            onClick={handleDecreaseProductQuantity}
            disabled={quantity === 1 ? true : false}
          >
            -
          </S.ChangeQuantity>
          <S.ChangeQuantity onClick={handleIncreaseProductQuantity}>
            +
          </S.ChangeQuantity>
        </div>
      </S.Price>
    </S.Container>
  );
};

export default CartProduct;
